(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'lodash/range', 'lodash/chunk', 'lodash/flatten', 'lodash/map', 'lodash/find'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('lodash/range'), require('lodash/chunk'), require('lodash/flatten'), require('lodash/map'), require('lodash/find'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.range, global.chunk, global.flatten, global.map, global.find);
        global.helpers = mod.exports;
    }
})(this, function (exports, _range, _chunk, _flatten, _map, _find) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.itemStyles = exports.reorderData = exports.getOrder = exports.reinsert = exports.toColumns = exports.calculateVisiblePositions = exports.clamp = exports.springSetting = undefined;

    var _range2 = _interopRequireDefault(_range);

    var _chunk2 = _interopRequireDefault(_chunk);

    var _flatten2 = _interopRequireDefault(_flatten);

    var _map2 = _interopRequireDefault(_map);

    var _find2 = _interopRequireDefault(_find);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var springSetting = exports.springSetting = { stiffness: 150, damping: 16 };

    var clamp = exports.clamp = function clamp(n, min, max) {
        return Math.max(Math.min(n, max), min);
    };

    var calculateVisiblePositions = exports.calculateVisiblePositions = function calculateVisiblePositions(newOrder, width, height) {
        return newOrder.map(function (column, col) {
            return (0, _range2.default)(column.length + 1).map(function (item, row) {
                return [width * col, height * row];
            });
        });
    };

    var toColumns = exports.toColumns = function toColumns(data, columns) {
        return (0, _chunk2.default)(data, Math.ceil(data.length / columns));
    };

    var reinsert = exports.reinsert = function reinsert(array, colFrom, rowFrom, colTo, rowTo, columns, fixed) {
        rowTo = Math.min(rowTo, array[colTo].length - 1);

        var _array = array.slice(0);
        var val = _array[colFrom][rowFrom];

        _array[colFrom].splice(rowFrom, 1);
        _array[colTo].splice(rowTo === 0 && colTo !== colFrom && fixed ? rowTo + 1 : rowTo, 0, val);

        if (colTo !== colFrom && fixed) {
            var data = (0, _flatten2.default)(_array);
            _array = toColumns(data, columns);
        }

        return _array;
    };

    var getOrder = exports.getOrder = function getOrder(columns) {
        return (0, _flatten2.default)(columns);
    };

    var reorderData = exports.reorderData = function reorderData(data, columns, getKey) {
        var order = getOrder(columns);

        return getKey ? (0, _map2.default)(order, function (key) {
            return (0, _find2.default)(data, function (item) {
                return getKey(item) === key;
            });
        }) : (0, _map2.default)(order, function (row) {
            return data[Number(row)];
        });
    };

    var itemStyles = exports.itemStyles = {
        boxSizing: 'border-box',
        position: 'absolute',
        userSelect: 'none'
    };
});